// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fo","advertDetailHeaderLocation__value":"c-m_fp"};